// Enums

import { EnvName } from "src/app/shared/environment.enum";
// Packages
// import packageInfo from '../../package.json';

const scheme = 'https://';
const host = 'flowchestapi.azurewebsites.net';

//TestAPIURL
// const host = 'flowchesttest.azurewebsites.net';
// const host   = 'localhost:7116';
const path = '/';

const baseUrl = scheme + host + path;


//const baseUrl = scheme + host + path;

export const environment = {
  production: true,
  appName: 'Flowchest',
  envName: EnvName.PROD,
  defaultLanguage: 'en',
   webBaseUrl: "https://app.flowchest.com",
  apiBaseUrl: baseUrl,
  paypalClientId: '',
  paypalPlans: {
    starterMonthly: '',
    starterAnnual: '',
    growthMonthly: '',
    growthAnnual: '',
    creatorMonthly: '',
    // Starter plans with a 14-day $0 TRIAL billing cycle (create in the PayPal dashboard).
    starterMonthlyTrial: '',
    starterAnnualTrial: '',
  },
  environmentKey: '2517029690634020193',
  applicationKey: '2517029690757091351',
  // uploadImageUrl: 'https://swashcmsapi.azurewebsites.net/api/media/upload/image',
  // uploadVideoUrl: 'https://swashcmsapi.azurewebsites.net/api/media/upload/video',
  // imageStorageBaseUrl: 'https://seasycmstest.blob.core.windows.net/mediaimage/',
  // videoStorageBaseUrl: 'https://seasycmstest.blob.core.windows.net/mediavideo/'

  uploadImageUrl: 'api/media/upload/image',
  uploadVideoUrl: 'api/media/upload/video',
  enableAutoVideoThumbnails: false,
  generateThumbnailsUrl: 'api/media/video/thumbnails',
  uploadDocumentsUrl:'api/media/upload/documents',
  imageStorageBaseUrl: 'https://flowcheststorage.blob.core.windows.net/mediaimage/',
  videoStorageBaseUrl: 'https://flowcheststorage.blob.core.windows.net/mediavideo/',
  documentsStorageBaseUrl: 'https://flowcheststorage.blob.core.windows.net/documents/',
  /** Optional: user calendar conflict check during consultation booking (requires API). */
  userCalendar: {
    enabled: true,
    oauthGooglePath: "api/UserCalendar/oauth/google/start",
    oauthMicrosoftPath: "api/UserCalendar/oauth/microsoft/start",
    freeBusyPath: "api/UserCalendar/freebusy",
  },
};
